import { call, put, delay } from "redux-saga/effects";
import { getBalanceActions } from "../slices";
import { balanceApi } from "@services/api";

function* getBalanceWorker({ payload }) {
  yield delay(300);
  try {
    yield put(getBalanceActions.pending());
    const response = yield call(balanceApi.getBalance, payload);
    yield put(getBalanceActions.success(response));
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(getBalanceActions.failure(error));
    // TODO: handle callback | onFailure
  }
}

export { getBalanceWorker };
